module.exports = __webpack_public_path__ + "media/public/img/city-wonders-logo-2848c653e2b6e11595151979130fe028.svg";